<template>
  <component
    :is="to ? RouterLink : 'article'"
    v-bind="to ? { to } : {}"
    class="feature-card group relative block h-full overflow-hidden rounded-[1.8rem] border border-[var(--ce-border)] bg-[var(--ce-card)] p-5 backdrop-blur-xl transition duration-500 hover:-translate-y-1.5 hover:border-[var(--ce-border-strong)] hover:shadow-[var(--ce-shadow-soft)] focus-visible:outline-none focus-visible:ring-4 focus-visible:ring-violet-500/15"
  >
    <div class="feature-shine pointer-events-none absolute inset-0"></div>

    <div class="relative flex h-full flex-col">
      <div class="flex items-start justify-between gap-4">
        <div
          class="icon-shell grid h-11 w-11 place-items-center rounded-2xl text-violet-600 dark:text-violet-300"
        >
          <span class="material-symbols-outlined text-[19px]">
            {{ icon }}
          </span>
        </div>

        <span
          v-if="badge"
          class="rounded-full bg-violet-500/10 px-2.5 py-1 text-[9px] font-bold uppercase tracking-[0.1em] text-violet-600 dark:text-violet-300"
        >
          {{ badge }}
        </span>
      </div>

      <h4
        class="mt-6 text-base font-semibold tracking-[-0.02em] text-[var(--ce-strong)]"
      >
        {{ title }}
      </h4>

      <p
        class="mt-2 text-sm leading-6 text-[var(--ce-muted)]"
      >
        {{ desc }}
      </p>

      <div
        v-if="to"
        class="mt-auto flex items-center justify-between pt-6 text-[10px] font-semibold uppercase tracking-[0.11em] text-[var(--ce-muted-2)]"
      >
        <span>Explorar</span>
        <span class="transition duration-300 group-hover:translate-x-1">→</span>
      </div>
    </div>
  </component>
</template>

<script setup>
import { RouterLink } from 'vue-router'

defineProps({
  icon: { type: String, default: 'widgets' },
  title: { type: String, default: '' },
  desc: { type: String, default: '' },
  to: { type: String, default: '' },
  badge: { type: String, default: '' }
})
</script>

<style scoped>
.icon-shell {
  background: var(--ce-accent-soft);
  box-shadow:
    inset 0 0 0 1px rgba(124, 58, 237, 0.10);
}

.feature-shine {
  opacity: 0;
  background:
    radial-gradient(
      22rem circle at 15% 0%,
      rgba(124, 58, 237, 0.12),
      transparent 60%
    );
  transition: opacity 450ms ease;
}

.feature-card:hover .feature-shine {
  opacity: 1;
}
</style>
